import CompactToolbar from './compact-toolbar'

export const AmuiCompactToolbar = CompactToolbar

export default Vue => Vue.component(CompactToolbar.name, CompactToolbar)
